const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2eefb4958e837eed0e12b75f15d62142240b4667"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["botanica-boutique@long-forme"]={id:"2eefb4958e837eed0e12b75f15d62142240b4667"};
      